<template>
  <div class='why-choose' :style="whyChooseIsGrey ? 'background: #fafafa': ''">
    <div class="page-container">
      <div class="header">
        <div class="title">
          {{whyChoose.title}}
        </div>
        <div class="sub-title">
          {{whyChoose.subtitle}}
        </div>
      </div>
      <ul>
        <li v-for='(item, index) in whyChoose.list' :key='index' :style="item.style || {}">
          <div class="top">
            <img :src='item.img'/>
            <div class='whyChoose-title'>{{item.title}}</div>
          </div>

          <div>
            <p class='whyChoose-desc'>{{item.desc}}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    whyChooseIsGrey: {
      type: Boolean,
      default: false
    },
    whyChoose: {
      type: Object,
      default: () => {
        return {
          title: '为何选择我们',
          subtitle: '资深“互联网+通信”行业经验，核心技术优势，满足每个行业的个性化需求，助力马兰头始终保持业界领先',
          list: [
            {
              img: require('@/assets/resolution/onlineEducation/img_6_1.png'),
              title: '高清晰 低延时 大规模',
              desc: '业界领先的视频编解码及传输技术，保证专业级优化的音频通信质量、毫秒级传输延时，支持万人同时在线',
              style: {
                left: '130px',
                top: '40px',
                width: '374px',
              }
            },
            {
              img: require('@/assets/resolution/onlineEducation/img_6_2.png'),
              title: '多流视频编码、多路视频显示',
              desc: '同一终端支持多流视频编码及多路视频显示，满足行业特色应用，可接入外接设备及影像数据等内容',
              style: {
                right: '130px',
                top: '40px',
                width: '374px',
              }
            },
            {
              img: require('@/assets/resolution/onlineEducation/img_6_3.png'),
              title: '云计算架构 灵活部署',
              desc: '支持公有云、私有化快速部署、统一管控、弹性扩展、硬件高可用，确保数据稳定安全',
              style: {
                left: 0,
                top: '285px',
                width: '374px',
              }
            },
            {
              img: require('@/assets/resolution/onlineEducation/img_6_4.png'),
              title: '灵活的开发组件与场景封装',
              desc: '开放式平台接口，模块化设计，提供各类终端SDK服务，IM+音视频+推送的整体解决方案，客户只需要集成一个 SDK 即可满足各类场景',
              style: {
                right: 0,
                top: '250px',
                width: '374px',
              }
            },
            {
              img: require('@/assets/resolution/onlineEducation/img_6_5.png'),
              title: '快速集成',
              desc: '开发者可以通过SDK和云端OPEN API，最快30分钟即可实现音视频能力、互动能力的集成',
              style: {
                left: '130px',
                top: '490px',
                width: '374px',
              }
            },
            {
              img: require('@/assets/resolution/onlineEducation/img_6_6.png'),
              title: '弱网对抗能力强',
              desc: '针对主流硬件平台包进行性能优化。针对互联网传输的丢包，延时，带宽变化等情况，设计自适应码率控制，保证视频流畅度和高质量',
              style: {
                right: '130px',
                top: '490px',
                width: '374px',
              }
            },
          ]
        }
      }
    }
  }
}
</script>

<style lang='less' scoped>
  .why-choose {
    .desc {
      font-size: 24px;
      font-weight: 400;
      text-align: center;
      color: #333333;
      line-height: 33px;
      letter-spacing: -1px;
      margin-bottom: 80px;
      position:relative;
      top: -20px;
    }
    ul {
      position: relative;
      height: 700px;
      background-image: url('~@/assets/resolution/onlineEducation/new-bg-choose.png');
      background-size: 508px 250px;
      background-position: center;
      background-repeat: no-repeat;
      li {
        display: flex;
        position: absolute;
        text-align: center;
        justify-content: center;
        flex-direction: column;
        img {
          width: 50px;
          height: 50px;
          margin-right: 10px;
        }
        .whyChoose-title {
          font-size: 21px;
          font-weight: 600;
          color: #333333;
          line-height: 33px;
          letter-spacing: -1px;
          margin-top: 8px;
        }
        .whyChoose-desc {
          font-size: 18px;
          font-weight: 400;
          color: #666666;
          line-height: 25px;
          margin-top: 8px;
        }
      }
    }
  }
</style>
